import React, { useEffect, useRef, useState } from "react";
import { IoIosArrowDown, IoMdCheckmark, IoMdClose } from "react-icons/io";
import AuthButton from "../AuthButton/AuthButton";
import Input from "../Input/Input";
import DropDownComponent from "../DropDown/DropDown";
import { IoClose } from "react-icons/io5";
import { CgAttachment } from "react-icons/cg";
import { useSelector } from "react-redux";
import { addClient, updateClient } from "../../Actions/actions";
import { useDispatch } from "react-redux";
import Loader from "../Loader/Loader";
import DropDownCustom from "../DropDownCustom/DropDownCustom";
import { countries } from "../../countries";
import GoogleMapsWrapper from "../Input/AddressInput";
import moment from "moment";

const AddNewClientModal = ({ isOpen, onClose, onConfirm, edit }) => {
  const clientIndustry = [
    { label: "Technology", value: "Technology" },
    { label: "IT Consultant", value: "IT Consultant" },
    { label: "Manufacture", value: "Manufacture" },
  ];

  const companyActivitydata = [
    { label: "Consultancy", value: "Consultancy" },
    { label: "Marketing", value: "Marketing" },
    { label: "Finance", value: "Finance" },
    { label: "IT", value: "IT" },
    { label: "Design", value: "Design" },
  ];

  const subscriptionOptions = [
    { label: "Free Forever", value: "Free Forever" },
    { label: "Repotal Pro", value: "Repotal Pro" },
    { label: "Repotal Ultimate", value: "Repotal Ultimate" },
  ];
  const { loginData, loader, subLoader, singleClient } = useSelector(
    (state) => state.userReducer
  );
  console.log(singleClient, "singleClient", edit);
  const dispatch = useDispatch();
  const [step, setStep] = useState(2);
  const [allCities, setAllCities] = useState([]);
  // const [features, setFeatures] = useState([
  //   { name: "CRM", enabled: false },
  //   { name: "HRMS", enabled: false },
  //   { name: "Reporting and Analytics", enabled: false },
  //   { name: "Geolocation Services", enabled: false },
  //   { name: "User Management", enabled: false },
  // ]);

  const [errors, setErrors] = useState({});

  const [formData, setFormData] = useState({
    businessName: "",
    clientIndustry: "",
    subscriptionType: "",
    companyActivity: "",
    tradeLicenseNumber: "",
    vatTaxId: "",
    businessWhatsapp: "",
    phoneNumber: "",
    postalCode: "",
    businessAddress: "",
    businessCountry: "",
    businessCity: "",
    contactPersonName: "",
    email: "",
    contactPersonPhoneNumber: "",
    contactPersonWhatsapp: "",
    // crm: features[0].enabled,
    // hrms: features[1].enabled,
    // reportingAnalytics: features[2].enabled,
    // geolocationService: features[3].enabled,
    // userManagement: features[4].enabled,
    userManagement: true,

    dueDate: "",
    businessCountryCode: "",
    contactPersonCountryCode: "",
    contactPersonWhatsappCountryCode: "",
  });
  useEffect(() => {
    if (edit == true) {
      let data = {
        businessName: singleClient?.businessName,
        clientIndustry: singleClient?.clientIndustry,
        subscriptionType: singleClient?.subscriptionType,
        companyActivity: singleClient?.companyActivity,
        tradeLicenseNumber: singleClient?.tradeLicenseNumber,
        vatTaxId: singleClient?.vatTaxId,
        businessWhatsapp: singleClient?.businessWhatsapp,
        phoneNumber: singleClient?.phoneNumber,
        postalCode: singleClient?.postalCode,
        businessAddress: singleClient?.businessAddress,
        businessCountry: singleClient?.businessCountry,
        businessCity: singleClient?.businessCity,
        contactPersonName: singleClient?.contactPersonName,
        email: singleClient?.email,
        contactPersonPhoneNumber: singleClient?.contactPersonPhoneNumber,
        contactPersonWhatsapp: singleClient?.contactPersonWhatsapp,
        dueDate: singleClient?.dueDate,
        businessCountryCode: singleClient?.businessCountryCode,
        contactPersonCountryCode: singleClient?.contactPersonCountryCode,
        contactPersonWhatsappCountryCode:
          singleClient?.contactPersonWhatsappCountryCode,
      };
      let featureData = [
        { name: "CRM", enabled: singleClient?.crm },
        { name: "HRMS", enabled: singleClient?.hrms },
        {
          name: "Reporting and Analytics",
          enabled: singleClient?.reportingAnalytics,
        },
        {
          name: "Geolocation Services",
          enabled: singleClient?.geolocationService,
        },
        { name: "User Management", enabled: singleClient?.userManagement },
      ];
      // setFeatures([...featureData])
      setFormData({ ...data });

      let cityData = countries?.findIndex(
        (element) => element?.country == singleClient?.businessCountry
      );
      setAllCities(countries[cityData]?.city);
    }
  }, [singleClient]);
  // useEffect(() => {

  //   setFormData((prevData) => ({
  //     ...prevData,
  //     crm: features[0].enabled,
  //     hrms: features[1].enabled,
  //     reportingAnalytics: features[2].enabled,
  //     geolocationService: features[3].enabled,
  //     userManagement: features[4].enabled,
  //   }));
  // }, [features]);
  const reset = () => {
    setFormData({
      businessName: "",
      clientIndustry: "",
      subscriptionType: "",
      companyActivity: "",
      tradeLicenseNumber: "",
      vatTaxId: "",
      businessWhatsapp: "",
      phoneNumber: "",
      postalCode: "",
      businessAddress: "",
      businessCountry: "",
      businessCity: "",
      contactPersonName: "",
      email: "",
      contactPersonPhoneNumber: "",
      contactPersonWhatsapp: "",
      // crm: false,
      // hrms: false,
      // reportingAnalytics: false,
      // geolocationService: false,
      userManagement: true,
      dueDate: "",
    });
    // setFeatures([
    //   { name: "CRM", enabled: false },
    //   { name: "HRMS", enabled: false },
    //   { name: "Reporting and Analytics", enabled: false },
    //   { name: "Geolocation Services", enabled: false },
    //   { name: "User Management", enabled: false },
    // ])
    setErrors({});
  };
  console.log(formData, "poi");

  if (!isOpen) return null;

  const validateForm = () => {
    let newErrors = {};
    if (step == 1) {
      if (!formData.businessName) {
        newErrors.businessName = "Business Name is required";
      }
      if (!formData.clientIndustry) {
        newErrors.clientIndustry = "Select Client Industry";
      }
      if (!formData.subscriptionType) {
        newErrors.subscriptionType = "Select Subscription Type";
      }
      if (!formData.companyActivity) {
        newErrors.companyActivity = "Select Company Activity";
      }
      if (!formData.tradeLicenseNumber) {
        newErrors.tradeLicenseNumber = "Trade License Number is required";
      }
      if (!formData.vatTaxId) {
        newErrors.vatTaxId = "VAT/TAX ID is required";
      }
      if (!formData.businessWhatsapp) {
        newErrors.businessWhatsapp = "Business WhatsApp is required";
      }
      if (!formData.dueDate) {
        newErrors.dueDate = "Due Date is required";
      }

      if (!formData.businessCountry) {
        newErrors.businessCountry = "Select Business Country";
      }
      if (!formData.businessCity) {
        newErrors.businessCity = "Select Business City";
      }
      if (!formData.postalCode) {
        newErrors.postalCode = "Postal Code is required";
      }
      if (!formData.businessAddress) {
        newErrors.businessAddress = "Business address is required";
      }
    }
    if (step == 2) {
      if (!formData.contactPersonName) {
        newErrors.contactPersonName = "Contact Person's Name is required";
      }
      if (!formData.email) {
        newErrors.email = "Contact Email is required";
      }
      if (!formData.contactPersonPhoneNumber) {
        newErrors.contactPersonPhoneNumber = "Contact Number is required";
      }
      if (!formData.contactPersonWhatsapp) {
        newErrors.contactPersonWhatsapp = "Contact Number is required";
      }
    }
    console.log(newErrors, formData, "h");
    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const StepProgress = ({ currentStep }) => {
    const steps = [
      "Business Info",
      "Client Information",

      // "Feature Access"
    ];

    return (
      <div className="flex relative justify-between items-center w-full mx-auto my-6">
        <div className={`absolute top-3 w-full h-[2px] bg-slate-300`}></div>
        {steps.map((step, index) => {
          const isCompleted = index + 1 < currentStep;
          const isActive = index + 1 === currentStep;

          return (
            <div
              key={index}
              className="relative flex flex-col items-center bg-white"
              onClick={() => setStep(index + 1)}
            >
              <div
                className={`w-6 h-6 flex items-center justify-center rounded-full text-white font-semibold ${
                  isCompleted
                    ? "bg-gray-800"
                    : isActive
                    ? "bg-gray-800"
                    : "bg-gray-200"
                }`}
              >
                <IoMdCheckmark className=" text-sm text-white " />
              </div>
              <span className="mt-2 text-xs font-semibold text-gray-800 w-[80%] text-center">
                {step}
              </span>
            </div>
          );
        })}
      </div>
    );
  };

  const handleNext = () => {
    if (
      step == 1
      // || step == 2
    ) {
      if (validateForm()) {
        setStep((prev) => prev + 1);
      }
    } else {
      if (edit == true) {
        dispatch(
          updateClient(
            singleClient?.id,
            formData,
            loginData?.accessToken,
            () => {
              onConfirm();
              onClose();
              reset();
              setStep(1);
              // dispatch(
              //   getClientbyid(loginData?.accessToken, singleClient?.id, () => {})
              // );
            }
          )
        );
      } else {
        dispatch(
          addClient(formData, loginData?.accessToken, () => {
            onClose();
            reset();
            onConfirm();
            setStep(1);
          })
        );
      }
    }
  };

  const handlePrevStep = () => {
    setStep(step - 1);
  };
  const clientIndustryOptions = [...clientIndustry];

  const subscriptionOptionsData = [...subscriptionOptions];

  const companyActivityOptions = [...companyActivitydata];
  const companyCountryOptions = countries.map((country) => ({
    value: country.country,
    label: country.country,
    cities: country.city,
  }));
  const companyCityOptions = allCities?.map((city) => ({
    value: city,
    label: city,
  }));

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 ">
      <div
        onClick={() => {
          onClose();
          reset();
        }}
        className="bg-gray-800 opacity-50 fixed inset-0"
      ></div>

      <div className="bg-white rounded-lg p-6 z-10 max-w-2xl max-h-[90%] overflow-scroll w-full shadow-lg scrollbar-none">
        <div className="flex flex-row items-center justify-between">
          <p className="font-bold text-md text-gray-800">
            {edit ? "Edit Client" : "Add New Client"}
          </p>
          <div
            className="bg-slate-100 hover:bg-slate-300 cursor-pointer rounded-full p-1 transition"
            onClick={() => {
              onClose();
              reset();
            }}
          >
            <IoMdClose className="text-lg text-gray-800" />
          </div>
        </div>

        <StepProgress currentStep={step} />

        {step === 1 ? (
          <div>
            <Input
              float={true}
              label={"Business Name*"}
              placeholder={"Business name"}
              value={formData.businessName}
              onChange={(e) => {
                setFormData({ ...formData, businessName: e.target.value });
                setErrors({ ...errors, businessName: "" });
              }}
              error={errors.businessName}
            />

            <div className="flex flex-wrap gap-4 w-full z-10 ">
              <div className="md:w-[48.5%] sm:w-full">
                <DropDownCustom
                  selectedValue={clientIndustryOptions?.find(
                    (option) => option.label === formData.clientIndustry
                  )}
                  handleChanges={(option) => {
                    setFormData({ ...formData, clientIndustry: option.label });
                    setErrors({ ...errors, clientIndustry: "" });
                  }}
                  options={clientIndustryOptions}
                  isSearchable={false}
                  label="Client Industry*"
                  placeholder="Select Industry"
                />
              </div>
              <div className="md:w-[48.5%] sm:w-full sm:-mt-3 md:-mt-0">
                <DropDownCustom
                  selectedValue={subscriptionOptionsData?.find(
                    (option) => option.value === formData.subscriptionType
                  )}
                  handleChanges={(option) => {
                    setFormData({
                      ...formData,
                      subscriptionType: option.value,
                    });
                    setErrors({ ...errors, subscriptionType: "" });
                  }}
                  options={subscriptionOptionsData}
                  isSearchable={false}
                  label="Subscription Type*"
                  placeholder="Select Subscription"
                />
              </div>
            </div>
            <div className="flex flex-wrap items-center gap-4 w-full z-10 mt-6 ">
              <div className="md:w-[48.5%] sm:w-full lg:-mt-4">
                <DropDownCustom
                  selectedValue={companyActivityOptions?.find(
                    (option) => option.value === formData.companyActivity
                  )}
                  handleChanges={(option) => {
                    setFormData({ ...formData, companyActivity: option.value });
                    setErrors({ ...errors, companyActivity: "" });
                  }}
                  options={companyActivityOptions}
                  isSearchable={false}
                  // label="Company Activity"
                  placeholder="Select Activity"
                  label="Select Activity*"
                />
              </div>
              <div className="md:w-[48.5%] sm:w-full sm:-mt-3 md:-mt-0">
                <Input
                  type="date"
                  float={true}
                  label={"Due Date*"}
                  value={moment(formData?.dueDate).format("YYYY-MM-DD")}
                  onChange={(e) => {
                    setFormData({ ...formData, dueDate: e.target.value });
                    setErrors({ ...errors, dueDate: "" });
                  }}
                  error={errors.dueDate}
                  name="dueDate"
                  className="lg:mt-2"
                />
                {errors.startFrom && (
                  <p className="text-red-500 text-sm">{errors.startFrom}</p>
                )}
                {console.log(formData.dueDate, "formData.dueDate")}
              </div>
            </div>

            <div className="flex lg:flex-row gap-4 md:flex-col sm:flex-col mt-6">
              <Input
                float={true}
                label={"Trade license number*"}
                placeholder={"1234343"}
                value={formData.tradeLicenseNumber}
                onChange={(e) => {
                  setFormData({
                    ...formData,
                    tradeLicenseNumber: e.target.value,
                  });
                  setErrors({ ...errors, tradeLicenseNumber: "" });
                }}
                error={errors.tradeLicenseNumber}
              />
              <Input
                float={true}
                label={"VAT/TAX ID*"}
                placeholder={"Enter VAT"}
                value={formData.vatTaxId}
                onChange={(e) => {
                  setFormData({ ...formData, vatTaxId: e.target.value });
                  setErrors({ ...errors, vatTaxId: "" });
                }}
                error={errors.vatTaxId}
              />
            </div>

            <div className="flex lg:flex-row gap-4 md:flex-col sm:flex-col mt-6">
              <Input
                float={true}
                label={"Postal Code*"}
                placeholder={"Postal Code"}
                value={formData.postalCode}
                onChange={(e) => {
                  setFormData({ ...formData, postalCode: e.target.value });
                  setErrors({ ...errors, postalCode: "" });
                }}
                error={errors.postalCode}
              />
              <Input
                isPhoneNumber
                className={""}
                countryCodeValue={formData?.businessCountryCode}
                onCountryChange={(newCountryCode) => {
                  setFormData((prev) => ({
                    ...prev,
                    businessCountryCode: newCountryCode,
                  }));
                }}
                placeholder={"Business Whatsapp"}
                value={formData.businessWhatsapp}
                onChange={(e) => {
                  setFormData((prev) => ({
                    ...prev,
                    businessWhatsapp: e.target.value,
                  }));

                  setErrors((prev) => ({ ...prev, businessWhatsapp: "" }));
                }}
                error={errors.businessWhatsapp}
              />
            </div>

            <GoogleMapsWrapper
              errors={errors}
              setErrors={setErrors}
              formData={formData}
              setFormData={setFormData}
            />
            <div className="flex flex-wrap gap-4 w-full">
              <div className="md:w-[48.5%] sm:w-full">
                <DropDownCustom
                  selectedValue={companyCountryOptions?.find(
                    (option) => option.value === formData.businessCountry
                  )}
                  handleChanges={(option) => {
                    setAllCities(option?.cities);
                    setFormData({ ...formData, businessCountry: option.value });
                    setErrors({ ...errors, businessCountry: "" });
                  }}
                  options={companyCountryOptions}
                  isSearchable={true}
                  label="Business Country*"
                  placeholder="Select Country"
                />
              </div>
              <div className="md:w-[48.5%] sm:w-full sm:-mt-3 md:-mt-0">
                <DropDownCustom
                  selectedValue={companyCityOptions?.find(
                    (option) => option.value === formData.businessCity
                  )}
                  handleChanges={(option) => {
                    setFormData({ ...formData, businessCity: option.value });
                    setErrors({ ...errors, businessCity: "" });
                  }}
                  options={companyCityOptions}
                  isSearchable={true}
                  label="Business City*"
                  placeholder="Select City"
                />
              </div>
            </div>
          </div>
        ) : step === 2 ? (
          <div>
            <div className="flex lg:flex-row gap-4 md:flex-col sm:flex-col mt-6">
              <Input
                float={true}
                label={"Contact Person’s Name"}
                placeholder={"Contact Person name"}
                value={formData.contactPersonName}
                onChange={(e) => {
                  setFormData({
                    ...formData,
                    contactPersonName: e.target.value,
                  });
                  setErrors({ ...errors, contactPersonName: "" });
                }}
                error={errors.contactPersonName}
              />
              <Input
                placeholder={"Email"}
                label={"Email*"}
                float={true}
                value={formData.email}
                onChange={(e) => {
                  setFormData({ ...formData, email: e.target.value });
                  setErrors({ ...errors, email: "" });
                }}
                error={errors.email}
              />
            </div>
            <div className="flex lg:flex-row gap-4 md:flex-col sm:flex-col">
              <Input
                isPhoneNumber
                placeholder={"Contact Number 1"}
                countryCodeValue={formData?.contactPersonCountryCode}
                onCountryChange={(newCountryCode) => {
                  setFormData((prev) => ({
                    ...prev,
                    contactPersonCountryCode: newCountryCode,
                  }));
                }}
                className={"sm:mt-6 lg:mt-6 "}
                value={formData.contactPersonPhoneNumber}
                onChange={(e) => {
                  setFormData({
                    ...formData,
                    contactPersonPhoneNumber: e.target.value,
                  });
                  setErrors({ ...errors, contactPersonPhoneNumber: "" });
                }}
                error={errors.contactPersonPhoneNumber}
              />
              <Input
                isPhoneNumber
                countryCodeValue={formData?.contactPersonWhatsappCountryCode}
                onCountryChange={(newCountryCode) => {
                  setFormData((prev) => ({
                    ...prev,
                    contactPersonWhatsappCountryCode: newCountryCode,
                  }));
                }}
                placeholder={"Bussiness WhatsApp"}
                className={"sm:mt-1 lg:mt-6"}
                value={formData.contactPersonWhatsapp}
                onChange={(e) => {
                  setFormData({
                    ...formData,
                    contactPersonWhatsapp: e.target.value,
                  });
                  setErrors({ ...errors, contactPersonWhatsapp: "" });
                }}
                error={errors.contactPersonWhatsapp}
              />
            </div>
          </div>
        ) : (
          <div>
            <div className="bg-gray-100 rounded-lg p-6">
              {/* {features.map((feature, index) => (
                <div
                  key={feature.name}
                  className="flex justify-between items-center py-2"
                >
                  <span className="text-gray-800 text-sm font-regular">
                    {feature.name}
                  </span>
                  <button
                    className={`w-10 h-5 rounded-full flex items-center px-1 transition ${feature.enabled ? "bg-primary" : "bg-gray-300"
                      }`}
                    onClick={() => {
                      const updatedFeatures = features.map((f, i) =>
                        i === index ? { ...f, enabled: !f.enabled } : f
                      );
                      setFeatures(updatedFeatures);
                    }}
                  >
                    <div
                      className={`w-4 h-4 bg-white rounded-full shadow-md transform transition ${feature.enabled ? "translate-x-4" : "translate-x-0"
                        }`}
                    ></div>
                  </button>
                </div>
              ))} */}
            </div>
          </div>
        )}

        <div className="flex justify-end space-x-4 mt-12 ">
          {subLoader ? (
            <Loader />
          ) : (
            <>
              <AuthButton
                className="bg-white px-4  border border-gray-300 rounded-md hover:bg-gray-100"
                width={"20%"}
                title={step > 1 ? "Previous" : "Cancel"}
                onClick={() => {
                  if (step > 1) {
                    handlePrevStep();
                  } else {
                    onClose();
                    reset();
                  }
                }}
              />

              <AuthButton
                onClick={handleNext}
                width={"20%"}
                title={
                  step > 1
                    ? // step > 2
                      edit
                      ? "Edit"
                      : "Create"
                    : "Save and Next"
                }
                className="bg-primary hover:bg-gray-600 text-white  px-4 rounded-md"
              />
            </>
          )}
        </div>
      </div>
    </div>
  );
};
export default AddNewClientModal;
